import React from 'react';

import { SnackbarStyle, SnackbarContentWrapper } from "./Toast.style";
import { ToastType } from 'Redux/General/Actions';

// IMAGES
// import CloseIcon from '@material-ui/icons/Close';
function Toast(props) {
    return (
        <SnackbarStyle
            anchorOrigin={{
                vertical    : 'top',
                horizontal  : 'right',
            }}
            autoHideDuration  = {props.duration || 3000}
            open      = {props.open}
            onClose   = {props.handleClose}
        >
            <SnackbarContentWrapper
                className={`themed ${props.toastType === ToastType.SUCCESS && "success-toast"} ${props.toastType === ToastType.ERROR && "error-toast"}`}
                aria-describedby="client-snackbar"
                classes = {{
                    message   : "notification-message",
                }}
                message = {
                    <React.Fragment>
                        {props.message}
                    </React.Fragment>
                }
               /*  action={[
                    <IconButton
                        key           = "close"
                        aria-label    = "Close"
                        color         = "inherit"
                        className     = "close-icon"
                        onClick       = {props.handleClose}
                    >
                        <CloseIcon  />
                    </IconButton>,
                ]} */
            />
        </SnackbarStyle>
    )
}

export default Toast;